module.exports = __webpack_public_path__ + "static/img/chat-pass.e945a8fd.png";